import { render, staticRenderFns } from "./nav-header-typeahead.vue?vue&type=template&id=05990cc4&"
import script from "./nav-header-typeahead.vue?vue&type=script&lang=js&"
export * from "./nav-header-typeahead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports